import React, { useCallback } from "react";
import { generateDays, generateMonths } from "@/utils";
import { Tooltip } from "antd";
import { useDispatch } from "react-redux";
import cls from "classnames";
import styles from "./index.module.less";
import moment from "moment";

const weekdayLabels = ["S", "M", "T", "W", "T", "F", "S"];

function DateGrid({ startDate, endDate, dates = [] }) {
  const dispatch = useDispatch();
  const updateTime = useCallback(
    (value) => {
      dispatch.layer.updateFields({ time: moment(value, "YYYY-MM-DD") });
    },
    [dispatch]
  );
  const days = generateDays(startDate, endDate);
  const columns = days.length / 7;
  const width = columns * 15;
  const gridStyle = {
    width: `${width}px`,
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gridTemplateRows: `repeat(7, 1fr)`,
  };
  const months = generateMonths(days);
  const items = days.map((d, index) => {
    return (
      <div className="cell" key={`${index}-cell`}>
        {d && (
          <Tooltip title={d}>
            <div
              className={cls("date", { active: dates.includes(d) })}
              onClick={(e) => {
                e.preventDefault();
                updateTime(d);
              }}
            ></div>
          </Tooltip>
        )}
      </div>
    );
  });
  const wLabels = weekdayLabels.map((label, index) => {
    return (
      <div className="item" key={`weekday-label-${index}`}>
        {label}
      </div>
    );
  });
  const mLabels = months.map(({ name, column }, index) => {
    const monthStyle = {
      left: `${15 * (column - 1)}px`,
    };
    return (
      <div className="item" key={`month-label-${index}`} style={monthStyle}>
        {name}
      </div>
    );
  });
  return (
    <div className={styles.dateGrid}>
      <div className="month-label">{mLabels}</div>
      <div className="week-label">{wLabels}</div>
      <div className="body" style={gridStyle}>
        {items}
      </div>
    </div>
  );
}

export default DateGrid;
